/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEscalatorUp = createReactComponent("outline", "escalator-up", "IconEscalatorUp", [["path", { "d": "M19.5 7h-2.672a2 2 0 0 0 -1.414 .586l-8.414 8.414h-2.5a2.5 2.5 0 1 0 0 5h3.672a2 2 0 0 0 1.414 -.586l8.414 -8.414h1.5a2.5 2.5 0 1 0 0 -5z", "key": "svg-0" }], ["path", { "d": "M6 10v-7", "key": "svg-1" }], ["path", { "d": "M3 6l3 -3l3 3", "key": "svg-2" }]]);

export { IconEscalatorUp as default };
//# sourceMappingURL=IconEscalatorUp.mjs.map
